module.exports = __webpack_public_path__ + "img/route-highway.ea2774f6.svg";